@if (viewAll && translationEntries.length>0) {
  @if (hisobject[attributeName]?.length>0) {
    <div>
      <span hisImage="COMMENT_{{hisObjectLanguage.iso_639_1}}" title="{{(hisAttribute | hisUi) + ' ' + (hisObjectLanguageI18nKey |hisUi)}}"></span>
      <his-safe-html html={{hisobject[attributeName]}} language="{{hisObjectLanguage.iso_639_1}}"></his-safe-html>
      <div class="clearerSpaceAboveHalfEm"></div>
    </div>
  }
  @for (entry of translationEntries; track entry; let i = $index) {
    <div >
      <span hisImage="COMMENT_{{entry[0]}}" title="{{('cs.sys.hisng.translationLabel_' + entry[0]) | hisUi: (hisAttribute | hisUi)}}"></span>
      <his-safe-html html={{entry[1]}} language="{{entry[0]}}"></his-safe-html>
      @if (i<translationEntries.length-1) {
        <div class="clearerSpaceAboveHalfEm"></div>
      }
    </div>
  }
} @else {
  <his-safe-html [html]="translatedText" [language]="language"></his-safe-html>
}

